import type { ReactNode } from 'react';
import { cn } from '@shared/utils';
import { Text } from '@shared/widgets';

interface ISidebarSectionProps {
  className?: string;
  caption?: ReactNode;
  children: ReactNode;
}

export const SidebarSection = (props: ISidebarSectionProps) => {
  return (
    <div className={cn('flex w-80 flex-col gap-6 bg-white p-6 dark:bg-soft-black', 'max-[1440px]:w-full', props.className)}>
      <Text size='sm'>{props.caption}</Text>
      {props.children}
    </div>
  );
};
